import $ from 'jquery'
import select2 from 'select2'
import 'select2/dist/css/select2.min.css'

if (!$.fn.select2) {
  select2(window, $)
}

export { $ }
